export default {
  header: { height: 48 },
}
